import React from 'react'
import styles from './Style.module.css'
import { VOUCHER_TERMS } from '../../Utils/voucherTerms'

const TermsAndConditionsV2 = () => {
  return (
    <div className={`${styles.termAndConditionCard}`}>
        <h2 className={`${styles.titleSub} section-title`}>Terms and Conditions</h2>
        <div className={styles.content}>
          <ul>
            {VOUCHER_TERMS.map((term) => <li key={term}>{term}</li>)}
          </ul>
        </div>
        
    </div>
  )
}

export default TermsAndConditionsV2
